import type { QuizAnswerValue, QuizSingleStep } from "@/types/api.types";
import Arrows from "@/assets/icons/arrows.svg";
import FemaleFat from "@/assets/icons/female-fat.svg";
import FemaleFit from "@/assets/icons/female-fit.svg";
import MaleFat from "@/assets/icons/male-fat.svg";
import MaleFit from "@/assets/icons/male-fit.svg";
import parse from "html-react-parser";
import { formatWeight } from "@/utils/quizUtils";

const OfferBodyComparison = ({
  step,
  answers = {},
}: {
  step: QuizSingleStep;
  answers?: Record<string, QuizAnswerValue>;
}) => {
  const currentWeight = formatWeight(answers["weight_current"]);
  const goalWeight = formatWeight(answers["weight_goal"]);

  const isFemale = String(answers["gender"] ?? "").toLowerCase() === "female";
  const targetBodyFatPercent = isFemale ? 28 : 26;
  const fatIcon = isFemale ? FemaleFat : MaleFat;
  const fitIcon = isFemale ? FemaleFit : MaleFit;

  const staticContent = step?.staticContent;

  if (!staticContent) return null;

  return (
    <>
      <div className="p-4 md:p-8 border-[#E5E7EB] border rounded-[10px] flex flex-row items-center mx-auto w-full">
        <div className="flex flex-col gap-6 items-center max-w-[200px] w-full mx-auto">
          <span className="text-[#333] text-[18px] md:text-[20px] font-bold">
            {staticContent.currentLabel}
          </span>
          <img
            src={fatIcon}
            alt={isFemale ? "female current" : "male current"}
          />
          <div className="flex flex-col items-center text-[18px]">
            <span>{staticContent.currentWeightLabel}:</span>
            <span className="font-bold">{currentWeight}</span>
          </div>

          <div className="px-2 md:px-4 py-2 flex flex-col gap-2 items-center rounded-[10px] bg-[#F5F5F5]">
            <span className="text-[16px] font-bold">
              {staticContent.bodyFatLabel}
            </span>
            <div className="px-2 py-1 text-center">
              <span className="text-[12px] md:text-[14px]">
                {staticContent.approxLabel} 39%
              </span>
            </div>
          </div>
        </div>

        <div>
          <img src={Arrows} alt="Arrows" />
        </div>

        <div className="flex flex-col gap-6 items-center max-w-[200px] w-full mx-auto">
          <span className="text-[#333] text-[18px] md:text-[20px] font-bold">
            {staticContent.goalLabel}
          </span>
          <img src={fitIcon} alt={isFemale ? "female goal" : "male goal"} />
          <div className="flex flex-col items-center text-[18px]">
            <span>{staticContent.goalWeightLabel}:</span>
            <span className="font-bold text-[#039130]">{goalWeight}</span>
          </div>

          <div className="px-2 md:px-4 py-2 flex flex-col gap-2 items-center rounded-[10px] bg-[#F5F5F5]">
            <span className="text-[16px] font-bold">
              {staticContent.bodyFatLabel}
            </span>
            <div className="px-2 py-1 bg-[#DFF6E7] text-center rounded-sm">
              <span className="text-[12px] md:text-[14px] text-[#026E24] font-bold">
                {staticContent.approxLabel} {targetBodyFatPercent}%
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="p-4 md:p-6 bg-[#F5F5F5] rounded-[10px]">
        <span className="text-[16px] text-black">
          {parse(step?.subtitle ?? "")}
        </span>
      </div>
    </>
  );
};

export default OfferBodyComparison;
